/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} дана",
          "one": "за {0} дан",
          "other": "за {0} дана"
        },
        "past": {
          "few": "прије {0} дана",
          "one": "прије {0} дан",
          "other": "прије {0} дана"
        }
      },
      "day-narrow": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} дана",
          "one": "за {0} дан",
          "other": "за {0} дана"
        },
        "past": {
          "few": "прије {0} дана",
          "one": "прије {0} дан",
          "other": "прије {0} дана"
        }
      },
      "day-short": {
        "-1": "јуче",
        "-2": "прекјуче",
        "0": "данас",
        "1": "сутра",
        "2": "прекосутра",
        "future": {
          "few": "за {0} дана",
          "one": "за {0} дан",
          "other": "за {0} дана"
        },
        "past": {
          "few": "прије {0} дана",
          "one": "прије {0} дан",
          "other": "прије {0} дана"
        }
      },
      "hour": {
        "0": "овог сата",
        "future": {
          "few": "за {0} сата",
          "one": "за {0} сат",
          "other": "за {0} сати"
        },
        "past": {
          "few": "прије {0} сата",
          "one": "прије {0} сат",
          "other": "прије {0} сати"
        }
      },
      "hour-narrow": {
        "0": "овог сата",
        "future": {
          "few": "за {0} сата",
          "one": "за {0} сат",
          "other": "за {0} сати"
        },
        "past": {
          "few": "прије {0} сата",
          "one": "прије {0} сат",
          "other": "прије {0} сати"
        }
      },
      "hour-short": {
        "0": "овог сата",
        "future": {
          "few": "за {0} сата",
          "one": "за {0} сат",
          "other": "за {0} сати"
        },
        "past": {
          "few": "прије {0} сата",
          "one": "прије {0} сат",
          "other": "прије {0} сати"
        }
      },
      "minute": {
        "0": "овог минута",
        "future": {
          "few": "за {0} минута",
          "one": "за {0} минут",
          "other": "за {0} минута"
        },
        "past": {
          "few": "прије {0} минута",
          "one": "прије {0} минут",
          "other": "прије {0} минута"
        }
      },
      "minute-narrow": {
        "0": "овог минута",
        "future": {
          "few": "за {0} минута",
          "one": "за {0} минут",
          "other": "за {0} минута"
        },
        "past": {
          "few": "прије {0} мин.",
          "one": "прије {0} мин.",
          "other": "прије {0} мин."
        }
      },
      "minute-short": {
        "0": "овог минута",
        "future": {
          "few": "за {0} минута",
          "one": "за {0} минут",
          "other": "за {0} минута"
        },
        "past": {
          "few": "прије {0} минута",
          "one": "прије {0} минут",
          "other": "прије {0} минута"
        }
      },
      "month": {
        "-1": "прошлог мјесеца",
        "0": "овог мјесеца",
        "1": "сљедећег мјесеца",
        "future": {
          "few": "за {0} мјесеца",
          "one": "за {0} мјесец",
          "other": "за {0} мјесеци"
        },
        "past": {
          "few": "прије {0} мјесеца",
          "one": "прије {0} мјесец",
          "other": "прије {0} мјесеци"
        }
      },
      "month-narrow": {
        "-1": "прош. мјес.",
        "0": "ов. мјес.",
        "1": "сљ. мјес.",
        "future": {
          "few": "за {0} мјес.",
          "one": "за {0} мјес.",
          "other": "за {0} мјес."
        },
        "past": {
          "few": "прије {0} мјес.",
          "one": "прије {0} мјес.",
          "other": "прије {0} мјес."
        }
      },
      "month-short": {
        "-1": "прош. мјесеца",
        "0": "овог мјес.",
        "1": "сљед. мјесеца",
        "future": {
          "few": "за {0} мјесеца",
          "one": "за {0} мјесец",
          "other": "за {0} мјесеци"
        },
        "past": {
          "few": "прије {0} мјесеца",
          "one": "прије {0} мјесец",
          "other": "прије {0} мјесеци"
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "прошло тромјесечје",
        "0": "ово тромјесечје",
        "1": "сљедеће тромјесечје",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-narrow": {
        "-1": "прошло тромјесечје",
        "0": "ово тромјесечје",
        "1": "сљедеће тромјесечје",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "quarter-short": {
        "-1": "прошло тромјесечје",
        "0": "ово тромјесечје",
        "1": "сљедеће тромјесечје",
        "future": {
          "other": "+{0} Q"
        },
        "past": {
          "other": "-{0} Q"
        }
      },
      "second": {
        "0": "сада",
        "future": {
          "few": "за {0} секунде",
          "one": "за {0} секунд",
          "other": "за {0} секунди"
        },
        "past": {
          "few": "прије {0} секунде",
          "one": "прије {0} секунд",
          "other": "прије {0} секунди"
        }
      },
      "second-narrow": {
        "0": "сада",
        "future": {
          "few": "за {0} секунде",
          "one": "за {0} сек.",
          "other": "за {0} секунди"
        },
        "past": {
          "few": "прије {0} сек.",
          "one": "прије {0} сек.",
          "other": "прије {0} сек."
        }
      },
      "second-short": {
        "0": "сада",
        "future": {
          "few": "за {0} секунде",
          "one": "за {0} сек.",
          "other": "за {0} секунди"
        },
        "past": {
          "few": "прије {0} сек.",
          "one": "прије {0} сек.",
          "other": "прије {0} сек."
        }
      },
      "week": {
        "-1": "прошле седмице",
        "0": "ове седмице",
        "1": "сљедеће седмице",
        "future": {
          "few": "за {0} седмице",
          "one": "за {0} седмицу",
          "other": "за {0} седмица"
        },
        "past": {
          "few": "прије {0} седмице",
          "one": "прије {0} седмицу",
          "other": "прије {0} седмица"
        }
      },
      "week-narrow": {
        "-1": "прош. седм.",
        "0": "ове седм.",
        "1": "сљ. седм.",
        "future": {
          "few": "за {0} седм.",
          "one": "за {0} седм.",
          "other": "за {0} седм."
        },
        "past": {
          "few": "прије {0} седм.",
          "one": "прије {0} седм.",
          "other": "прије {0} седм."
        }
      },
      "week-short": {
        "-1": "прош. седм.",
        "0": "ове седм.",
        "1": "сљ. седм.",
        "future": {
          "few": "за {0} седм.",
          "one": "за {0} седм.",
          "other": "за {0} седм."
        },
        "past": {
          "few": "прије {0} седм.",
          "one": "прије {0} седм.",
          "other": "прије {0} седм."
        }
      },
      "year": {
        "-1": "прошле године",
        "0": "ове године",
        "1": "сљедеће године",
        "future": {
          "few": "за {0} године",
          "one": "за {0} годину",
          "other": "за {0} година"
        },
        "past": {
          "few": "прије {0} године",
          "one": "прије {0} годину",
          "other": "прије {0} година"
        }
      },
      "year-narrow": {
        "-1": "прош. године",
        "0": "ове год.",
        "1": "сљед. године",
        "future": {
          "few": "за {0} године",
          "one": "за {0} годину",
          "other": "за {0} година"
        },
        "past": {
          "few": "прије {0} године",
          "one": "прије {0} годину",
          "other": "прије {0} година"
        }
      },
      "year-short": {
        "-1": "прош. године",
        "0": "ове год.",
        "1": "сљед. године",
        "future": {
          "few": "за {0} године",
          "one": "за {0} годину",
          "other": "за {0} година"
        },
        "past": {
          "few": "прије {0} године",
          "one": "прије {0} годину",
          "other": "прије {0} година"
        }
      }
    },
    "locale": "bs-Cyrl"
  });
}